{
  "community": {
    "name": "Community",
    "shortDescription": "Single account with free activities",
    "features": [
      "Find and share activities",
      "Unlimited activity cloud storage",
      "Access to Premium Activities"
    ],
    "price": "Free",
    "termName": "Lifetime"
  },
  "personal": {
    "name": "Personal",
    "shortDescription": "Single account with custom activities",
    "features": [
      "Create and edit activities online",
      "Includes personal playlist",
      "Access activities on the go"
    ]
  },
  "professional": {
    "name": "Professional",
    "shortDescription": "Single account with multiple students",
    "features": [
      "Manage student assignments",
      "Monitor student progress",
      "Collaborate with team members"
    ]
  },
  "organization": {
    "name": "Organization",
    "shortDescription": "Multiple accounts with multiple students",
    "features": [
      "Instructor management",
      "Organization level reporting",
      "Enterprise privacy settings"
    ],
    "price": "Contact Us",
    "termName": "1-5 Year Terms"
  },
  "trialLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Desktop editor preview",
    "note": "Try it <1>$t(common:action.free)</1> for 30 days!",
    "price": "Free",
    "termName": "30-Day Trial",
    "footerNote": "1 install"
  },
  "boardmakerLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Complete desktop editor",
    "note": "",
    "termName": "One-Time Purchase",
    "footerNote": "2 installs per user"
  },
  "licenseRequest": {
    "name": "Boardmaker 7",
    "shortDescription": "Multiple licenses for organizations",
    "note": "",
    "price": "Contact Us",
    "termName": "Volume Discounts",
    "footerNote": "2 installs per user"
  }
}
